<template>
  <div class="p-4">
    <h4>{{ chartRoute.title }}</h4>
    <p>The Pandora Papers shows that more than 300 politicians, from more than 90 countries and territories, had offshore companies in secrecy jurisdictions.</p>
    <stacked-bar-chart
      :data="tsv"
      :fixed-height="fixedHeight"
      class="my-4"
      hide-empty-values
      label-field="provider"
      relative />
    <p class="text-muted mt-2 small text-right">Source: Pandora Papers data</p>
  </div>
</template>

<script>
import chart from '../mixins/chart'

export default {
  mixins: [chart],
  name: 'ChartProviderPoliticiansByRegion',
  computed: {
    tsv () {
      return this.$options.tsv
    }
  }
}
</script>

<tsv>
provider	Africa	Americas	Asia	Europe	Middle East
Alcogal	50	119	40	86	28
Cititrust	0	1	0	2	0
Trident Trust	10	19	34	17	21
Asiaciti Trust	3	6	10	6	1
Fidelity	0	0	2	6	2
OMC Group	0	16	4	1	0
SFM	9	0	0	8	1
Alpha	1	0	3	7	0
AABOL	4	0	1	3	0
Commence BVI	1	0	3	0	0
GDG	0	2	0	0	0
DADLAW	0	0	7	9	1
</tsv>
